module.exports = __webpack_public_path__ + "static/images/fields/percent_field.svg";